export default () => {
  if (!localStorage.getItem('cookie:accepted')) {
    return;
  }

  if (localStorage.getItem('cookie:accepted') !== 'true') {
    return;
  }

  let s1=document.createElement("script");
  let s0=document.getElementsByTagName("script")[0];
  s1.async=true;
  s1.setAttribute('id', 'ze-snippet');
  s1.src='https://static.zdassets.com/ekr/snippet.js?key=14a1e53e-8c3d-4e09-b4b6-c4430899149a';
  s0.parentNode.insertBefore(s1,s0);
};
